import { AddressProps } from './address.type'
import { AccountLevelProps } from './account-level.type'
import { UserProps } from './user.type'
import { FinanceProfileProps } from './finance-profile.type'
import { LeadProps } from './leads.type'

export enum ProfileTaxStatusEnum {
  pending = 'pending',
  review = 'review',
  invalid = 'invalid',
  completed = 'completed',
}

export enum ProfileMoscowsClassificationEnum {
  'must' = 'must',
  'should' = 'should',
  'could' = 'could',
  'wont' = 'wont',
}

export enum ProfileCustomerStatusEnum {
  active = 'active',
  churn = 'churn',
  passive_churn = 'passive_churn',
}

export enum ProfileTypeEnum {
  inbound = 'inbound',
  outbound = 'outbound',
  inbound_reactivation = 'inbound_reactivation',
  outbound_reactivation = 'outbound_reactivation',
}

export enum ProfileCustomerTypeEnum {
  manufacturer = 'manufacturer',
  manufacturer_and_provider = 'manufacturer_and_provider',
  reseller = 'reseller',
  builder = 'builder',
  building_materials_store = 'building_materials_store',
}

export enum ProfileTrafficTypeEnum {
  'paid' = 'paid',
  'organic' = 'organic',
  'direct' = 'direct',
  'referral' = 'referral',
  'unknown' = 'unknown',
}
export enum ProfileSelectedDeliveryPeriodsEnum {
  'morning' = 'morning',
  'afternoon' = 'afternoon',
  'night' = 'night',
}

export enum ProfileSelectedDeliveryDaysEnum {
  'monday' = 'monday',
  'tuesday' = 'tuesday',
  'wednesday' = 'wednesday',
}

export interface ProfileProps {
  uuid: string
  name: string
  phone: string
  email: string
  companyName: string
  attributes: Record<string, string | string[]>
  createdAt: string
  addresses: AddressProps[]
  addressProof?: string
  accountLevel: AccountLevelProps
  accountLevelSlug?: string
  moscowClassification: string
  keyAccountManager: UserProps
  keyAccountManagerId: string
  constitutiveAct?: string
  customerLevel: AccountLevelProps
  customerLevelSlug?: string
  statusHistory: Record<string, string>
  isFraudulent: boolean
  cfdi: string
  paymentMethod: string
  paymentForm: string
  cohort?: string
  financeProfile: FinanceProfileProps
  updatedAt: string
  taxSituation: string
  taxStatus: keyof typeof ProfileTaxStatusEnum
  taxComplianceCertificate?: string
  taxStatusCompletedAt?: string
  taxStatusCompletedBy?: {
    name: string
    email: string
  }
  usersNames: string[]
  users: UserProps[]
  customerStatus: keyof typeof ProfileCustomerStatusEnum
  churnedAt: string
  type: keyof typeof ProfileTypeEnum
  customerType: keyof typeof ProfileCustomerTypeEnum
  trafficSource: keyof typeof ProfileTrafficTypeEnum
  legalRepresentative?: {
    name: string
    phone: string
    email: string
    idDocument: string
    addToAccount?: boolean
    powerOfAttorney?: string
  }
  paymentsRepresentative?: {
    name: string
    phone: string
    email: string
    addToAccount?: boolean
  }
  leads?: LeadProps[]
  selectedDeliveryPeriods?: (keyof typeof ProfileSelectedDeliveryPeriodsEnum)[]
  selectedDeliveryDays?: (keyof typeof ProfileSelectedDeliveryDaysEnum)[]
}

export interface ProfileListWithPagesProps {
  count: number
  next?: string
  previous?: string
  results?: ProfileProps[]
}
